import React, { Component, Fragment } from 'react';

import getExperiment from 'lib/experiments/simple-test';
import * as singleSpa from 'single-spa';
import * as ClassicApp from 'singlespa/apps/classic';

import { domReady, initializeLayers } from './doc-init';
import { GammaContextProvider } from './gamma-context-provider';

import LayerManager from 'gamma/components/layer-manager';

const IS_GAMMA_HEADER = getExperiment('gammaHeader').get('enabled');

const FooterUrls = {
  HELP:
    'http://help.trello.com/article/736-troubleshooting-browser-issues-with-trello',
  CONTACT: '/contact?context=load-failure&source=from%20in%20app%20footer',
};

class StaticChrome extends Component {
  componentDidMount() {
    initializeLayers();
    // Tell single-spa that you're ready for it to mount your application to the DOM
    ClassicApp.setElem(document.getElementById('classic'));
    singleSpa.start();
  }

  render() {
    const {
      ComponentWrapper,
      Header,
      Overlays,
      BoardsMenu,
      LogoutTrigger,
    } = this.props.GammaContext;

    return (
      <Fragment>
        <LayerManager>
          {IS_GAMMA_HEADER ? (
            <ComponentWrapper>
              <BoardsMenu />
            </ComponentWrapper>
          ) : (
            <div id="boards-drawer" />
          )}
          <p id="notification" />
          <div id="surface">
            {IS_GAMMA_HEADER ? (
              <ComponentWrapper>
                <Header />
              </ComponentWrapper>
            ) : (
              <div id="header" />
            )}
            <div id="banners" />
            <div id="content" />
            <div id="footer">
              <div id="contact-us" style={{ display: 'none' }}>
                If you're having trouble loading Trello,{' '}
                <a href={FooterUrls.HELP} target="support">
                  check out our troubleshooting guide
                </a>{' '}
                or{' '}
                <a href={FooterUrls.CONTACT} target="contact">
                  contact us
                </a>!
              </div>
              <div id="footer-chrome" style={{ display: 'none' }} />
            </div>
          </div>
          {IS_GAMMA_HEADER && (
            <ComponentWrapper>
              <Fragment>
                <Overlays />
                <LogoutTrigger />
              </Fragment>
            </ComponentWrapper>
          )}
        </LayerManager>
        <div className="window-overlay">
          <div className="window">
            <a className="focus-dummy" href="#" />
            <div className="window-wrapper" />
          </div>
        </div>
        <div className="pop-over" />
        <div className="tooltip-container" />
        <div id="clipboard-container" />
      </Fragment>
    );
  }
}

export class Chrome extends Component {
  constructor(props) {
    super(props);

    domReady();
  }

  render() {
    return (
      // StaticChrome exists as a separate component because Chrome renders
      // asynchronously (in the case of the Gamma header), and we need to be
      // certain that the static HTML is rendered to the page before the life-
      // cycle methods run (componentDidMount initializes some Classic code
      // that selects and caches elements, so we need them to be present).
      <GammaContextProvider>
        {(GammaContext) => <StaticChrome GammaContext={GammaContext} />}
      </GammaContextProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./app/scripts/views/chrome/chrome-view.js